import toast from "react-hot-toast";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAgents } from "@/components/Agents/AgentsContext";
import { AGENTS_LOCAL_STORAGE_KEY } from "@/lib/agentsPersistence";

export function SettingsPage() {
  const {
    may,
    viewOnly,
    persistenceReady,
    persistenceSource,
    persistenceError,
    resetLocalDemo,
  } = useAgents();
  const canEdit = may("manage_agent_configuration") || may("manage_users");

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Settings</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Organization notification preferences. Escalation hooks for one agent live under Agent
          Configuration.
        </p>
      </div>

      {viewOnly ? (
        <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100">
          Standard role is view only for org settings.
        </p>
      ) : null}

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Notifications</CardTitle>
          <CardDescription>
            Channels and quiet hours for org-wide alerts (placeholder).
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid gap-3 sm:grid-cols-2">
            <label className="flex items-center justify-between rounded-md border border-gray-200 px-3 py-2 text-sm dark:border-white/10">
              Email digests
              <input type="checkbox" defaultChecked disabled={!canEdit} />
            </label>
            <label className="flex items-center justify-between rounded-md border border-gray-200 px-3 py-2 text-sm dark:border-white/10">
              Escalation push
              <input type="checkbox" defaultChecked disabled={!canEdit} />
            </label>
            <label className="flex items-center justify-between rounded-md border border-gray-200 px-3 py-2 text-sm dark:border-white/10">
              Quiet hours
              <input type="checkbox" disabled={!canEdit} />
            </label>
            <label className="flex items-center justify-between rounded-md border border-gray-200 px-3 py-2 text-sm dark:border-white/10">
              Credit pool warnings
              <input type="checkbox" defaultChecked disabled={!canEdit} />
            </label>
          </div>
          <Button
            type="button"
            disabled={!canEdit}
            onClick={() => toast.success("Notification settings save is a stub.")}
          >
            Save preferences
          </Button>
        </CardContent>
      </Card>

      <Card className="border-dashed">
        <CardHeader>
          <CardTitle className="text-base">Agent roster storage</CardTitle>
          <CardDescription>
            Hires, archives, connections, and schedules are stored in the Workforce database for
            your organization (D1). They stay available across browsers and builds. Soft archive
            only; agents are never hard-deleted.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-2">
          <p className="text-sm text-muted-foreground">
            Source:{" "}
            <span className="font-mono text-xs">
              {persistenceSource === "server"
                ? "server (org D1)"
                : persistenceSource === "loading"
                  ? "loading…"
                  : `local cache (${AGENTS_LOCAL_STORAGE_KEY})`}
            </span>
            {persistenceReady ? "" : " (hydrating…)"}
          </p>
          {persistenceError ? (
            <p className="text-sm text-amber-800 dark:text-amber-200">
              Server sync issue: {persistenceError}. Changes may stay in this browser until the API
              recovers.
            </p>
          ) : null}
          <Button
            type="button"
            variant="outline"
            disabled={!may("create_edit_archive_agents")}
            onClick={() => {
              resetLocalDemo();
              toast.success("Browser cache cleared. Reloading roster from the server.");
            }}
          >
            Reload roster from server
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
